export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#ffd400" },
        { className: "secondary-bg-colour", colour: "#2D343B" },
        { className: "navbar-bg-colour", colour: "#2D343B" }
    ],
    text: [
        { className: "primary-text", colour: "#000000" },
        { className: "secondary-text", colour: "#ffd400" }
    ],
    borders: [
        { className: "primary-border-colour", colour: "#ffd400" },
    ]
};
